import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        error: null,
        videos: null,
        loading: false,
        currentVideo: null
};

const vimeoLoadSuccess = (state, action) => {
    let videos = { ...action.videos.vimeoclip.elements };
    
    for(let key in videos) {
        videos[key].data["media"] = [ "video" ];
    }
    
    return updateObject( state, { loading: false, videos: videos } );
}

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.VIMEO_LOAD_START:
            return updateObject(state, { loading: true });
        case actionTypes.VIMEO_LOAD_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.VIMEO_LOAD_SUCCESS:
            return vimeoLoadSuccess(state, action);
        case actionTypes.VIMEO_SET_CURRENT_VIDEO:
            return updateObject(state, { currentVideo: action.video });
        default: 
            return state;
    }
}

export default reducer;
